import React from "react";
import { Link } from "@quintype/components";

import { string, number } from "prop-types";
import Headline from "../../atoms/headline";

import "./custom-headline.m.css";

const CustomHeadline = ({ text, color = "default", headerLevel = 2, headerType = 1, href }) => (
  <div styleName={`custom-headline ${color}`} className="custom-headline">
    <Link href={href}>
      <Headline text={text} headerLevel={headerLevel} headerType={headerType} />
    </Link>
  </div>
);

export default CustomHeadline;

CustomHeadline.propTypes = {
  text: string,
  color: string,
  headerType: number,
  headerLevel: number,
  href: string
};
